// extracted by mini-css-extract-plugin
module.exports = {"gpaTag":"GPA_gpaTag__2ZFi8","red":"GPA_red__6MBK1","green":"GPA_green__2tUy6","pale":"GPA_pale__3A9ua"};